function setTitle (title) {
    document.title = `${title} - SkillPills`
}

export default setTitle
